import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapPlaceToApiPlaceDto = (values: ICreateModelForm): IPostNewModel | {} => {
  let dataMapping: IPostNewModel | {} = {};

    dataMapping = {
      deleted: values.deleted,
      module: values.module,
      modelTypeID: +values.modelTypeID,
      description: values.description, 

    }
  
  return dataMapping;
}


export const createModel = ( {data} : {data: ICreateModelForm }): Promise<string> => {
  const model = mapPlaceToApiPlaceDto(data);
  return axiosDefaultApi.post(`/api/Models/InsertModel`, model);
};

type QueryFnType = typeof createModel;

type UseCreateModelOptions = {
  data: IPostNewModel | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateModel = ({ config }: UseCreateModelOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Τύποι Συσκευής.`, 500);
            console.error('Couldnt create new Model', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllModels"])
            addNotification("Ο Τύπος Συσκευής Δημιουργήθηκε.", 200);
            setIsNotificationVisible(true)  
          },
        ...config,
        mutationFn: createModel,
    })
}